import React, { useEffect, useState } from 'react'
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setDownloadAppBar } from '../../feature/userData/userData';
import logo from "../../icons/photos/chillLogo.png";

const HIDE_BANNER_SEGMENTS = new Set([
    'addLinkA',
    'addLinkB',
    'login',
    'signup',
    'signUpPro',
    'signUpCustomer',
    'forgotPassword',
    'resetPassword',
    'createPassword',
    'verifyEmailPhone',
    'activateUsers',
    'scanNew',
]);

const shouldHideDownloadBanner = (pathname) =>
    pathname.split('/').filter(Boolean).some((segment) => HIDE_BANNER_SEGMENTS.has(segment));

const DownloadAppBanner = () => {
    const { downloadAppBar, } = useSelector((state) => state.user);
    const { pathname } = useLocation();

    const dispatch = useDispatch();
    const hideBanner = shouldHideDownloadBanner(pathname);
    const showBanner = downloadAppBar && !hideBanner;

    // Check wether the device is desktop/android/iOS
    const [deviceType, setDeviceType] = useState(
        window.innerWidth < 768 ? 'mobile' : 'desktop'
    );
    const [osType, setOsType] = useState('android'); // Default to 'android'
    const [appLink, setAppLink] = useState('https://play.google.com/store/apps/details?id=com.chilll.app');

    useEffect(() => {
        const handleResize = () => {
            setDeviceType(window.innerWidth < 768 ? 'mobile' : 'desktop');
        };

        const detectOs = () => {
            const userAgent = navigator.userAgent.toLowerCase();
            if (/android/i.test(userAgent)) {
                setOsType('android');
                setAppLink('https://play.google.com/store/apps/details?id=com.chilll.app');
            } else if (/iphone|ipod/i.test(userAgent)) {
                setOsType('ios');
                setAppLink('https://apps.apple.com/us/app/apple-store/id1621747291');
            } else {
                setOsType('android'); // Default to Android if no match
                setAppLink('https://play.google.com/store/apps/details?id=com.chilll.app');
            }
        };

        detectOs();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {

        // console.log(deviceType, 'deviceType');


        if (deviceType === 'mobile' && !hideBanner) {
            dispatch(setDownloadAppBar(true));
        } else {
            dispatch(setDownloadAppBar(false));
        }
    }, [deviceType, osType, hideBanner, dispatch]);


    if (hideBanner) {
        return null;
    }

    return (
        <>
            {showBanner && <>
                <div
                    style={{
                        height: '110px',
                        width: '100%',
                        backgroundColor: '#f0d6a6',
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        zIndex: '99',
                    }}
                    className="p-3"
                >
                    <div className="row mx-0 h-100">
                        <div className="row">
                            <div className="col-8 h-100 d-flex align-items-center">

                                <div className="d-flex align-items-center flex-column me-2">
                                    <span
                                        className="fs-4 text-black cursor-pointer"
                                        onClick={() => {
                                            dispatch(setDownloadAppBar(false));
                                        }}
                                    >
                                        <i className="bi bi-x-circle"  ></i>
                                    </span>
                                </div>

                                <div className="d-flex justify-content-center flex-column">
                                    <img
                                        src={logo}
                                        style={{ width: "108px", }}
                                        alt=""
                                    />

                                    <div className="mt-1 d-flex  align-items-center">
                                        <span className="fs-7 text-black font-w600">{`Download our App for better experience`}</span>
                                    </div>
                                </div>

                            </div>

                            <div className="col-4 h-100 d-flex align-items-center justify-content-end">
                                <div>
                                    <a href={appLink} target="_blank" rel="noreferrer">
                                        <PrimaryButton
                                            buttonName={`GET NOW`}
                                            onClick={(e) => { }}
                                            // isLoading={loaderActive}
                                            loadingMessage={"Loading..."}
                                            style={{
                                                // width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                            }}
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
                <div style={{ height: '110px', width: '100%', }}></div>
            </>}
        </>
    )
}

export default DownloadAppBanner